
import React from 'react';

interface Point {
  x: number;
  y: number;
  timestamp: number;
  id: number;
}

interface TouchPointVisualizerProps {
  points: Point[];
}

/**
 * Visualizes touch points for debugging
 */
export const TouchPointVisualizer: React.FC<TouchPointVisualizerProps> = ({ points }) => {
  return (
    <>
      {points.map(point => (
        <div 
          key={point.id}
          className="touch-debug-point"
          style={{ 
            left: `${point.x}px`, 
            top: `${point.y}px`,
            opacity: 1 - (Date.now() - point.timestamp) / 3000,
            backgroundColor: 'red',
            width: '16px',
            height: '16px',
            borderRadius: '50%',
            position: 'fixed',
            pointerEvents: 'none',
            zIndex: 9999,
            transform: 'translate(-50%, -50%)'
          }}
          title={`Touch at (${point.x}, ${point.y})`}
        />
      ))}
    </>
  );
};
